/**
 * Stores build information. The string literals are replaces at compile time by `set_version.js`.
 */
export const buildInfo = {
    versionNumber: "0.1.0",
    versionName: "nightly 2024-04-18",
    versionChannel: "nightly",
    buildDate: "2024-04-18T00:05:40.187Z",
    commitHash: "a69b80b4bbc89aa8ef6dc1e334eb8345c6595153",
};
